import React, { useContext } from "react";
import { ListContext } from "context";
import Pagination from "./Pagination";
import DataCounter from "./DataCounter";

const Toolbar: React.FC = () => {
    const { isLoading } = useContext(ListContext);
    const { data } = useContext(ListContext);

    return (
        <React.Fragment>
            {!isLoading && data.pager.total > 0 && (
                <div className="crud-toolbar mt-8 grid grid-cols-3 items-center gap-4">
                    <div className="justify-self-start">
                        <DataCounter />
                    </div>
                    <div className="justify-self-center">
                        <Pagination />
                    </div>
                    <div />
                </div>
            )}
        </React.Fragment>
    );
};

export default Toolbar;
